<template>
  <div class="bbb-pages">
    <div class="bbb-how-to">
      <div class="how-to-play-section">
        <!-- <div class="htp-header">
          <h2 class="htp-title">HOW TO PLAY</h2>
        </div>

        <div class="htp-rules">
          <div class="htp-rule">
            <div class="htp-bullet"><span>1</span></div>
            <p>Tap produk LAKA sebanyak mungkin dalam waktu 15 detik. Kumpulkan poin tertinggi dan hati-hati, jangan tap buah-buahan atau poinmu akan berkurang! ☹️</p>
          </div>
          <div class="htp-rule">
            <div class="htp-bullet"><span>2</span></div>
            <p>Kumpulkan minimum 50+ points untuk dapatkan freebies. Good Luck! 😊</p>
          </div>
        </div> -->

        <div class="button-container">
          <button class="btn-back" @click="goBackToHome">
            <img src="/static/img/laka-event/laka-back-btn.svg" alt="Back" />
          </button>
          <button class="btn-play" @click="startGame">Play Now</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VendingMachineTracker from '@/mixins/vending-machine-tracker';
import connectionHelper from '@/mixins/connection-helper.js';

export default {
  name: 'PimplePopHowToPlay',
  mixins: [VendingMachineTracker, connectionHelper],
  data() {
    return {
      idleTimer: null,
      idleTimeout: 30000,
    };
  },
  computed: {
    isVnSource() {
      return this.$route.query.isvn;
    },
    url_next() {
      return '/laka-vending-machine-event/home';
    },
  },
  mounted() {
    this.startIdleTimer();
    this.addActivityListeners();
  },
  beforeDestroy() {
    this.destroyListener();
    this.clearIdleTimer();
    this.removeActivityListeners();
  },
  created() {
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },
  methods: {
    goBackToHome() {
      this.$router.push('/laka-vending-machine-event/scan-qr');
    },
    startGame() {
      this.$router.push('/laka-vending-machine-event/bbb-game-start');
    },

    startIdleTimer() {
      this.clearIdleTimer();
      this.idleTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.idleTimeout);
    },

    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },

    resetIdleTimer() {
      this.startIdleTimer();
    },

    handleAutoLogout() {
      this.$store
        .dispatch('userLogout')
        .then(() => {
          this.$router.push('/laka-vending-machine-event/scan-qr');
        })
        .catch(() => {
          this.$router.push('/laka-vending-machine-event/scan-qr');
        });
    },

    addActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.addEventListener(event, this.handleUserActivity, true);
      });
    },

    removeActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.removeEventListener(event, this.handleUserActivity, true);
      });
    },

    handleUserActivity() {
      this.resetIdleTimer();
    },
  },
};
</script>

<style lang="scss" scoped>
.bbb-how-to {
  min-height: 100vh;
  background: #000 url('/static/img/laka-event/laka-event-how-to-play.png') no-repeat top center;
  background-size: 100% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.how-to-play-section {
  width: 100%;
  padding: 0 100px 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.htp-header {
  background: linear-gradient(180deg, rgba(255, 231, 193, 1) 0%, rgba(201, 138, 94, 1) 100%);
  box-shadow: inset 0px -1px 30px 0px rgba(255, 255, 255, 1);
  border-radius: 6px;
  padding: 24px 36px;
}

.htp-title {
  font-family: 'Gmarket Sans', sans-serif;
  font-weight: 500;
  font-size: 50px;
  line-height: 1;
  text-transform: uppercase;
  text-align: center;
  color: #5e0223;
  margin: 0;
}

.htp-rules {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.htp-rule {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
}

.htp-bullet {
  flex: 0 0 63px;
  width: 63px;
  height: 63px;
  border-radius: 50%;
  background: linear-gradient(180deg, rgba(255, 231, 193, 1) 0%, rgba(201, 138, 94, 1) 100%);
  box-shadow: inset 0px -1px 30px 0px rgba(255, 255, 255, 1);
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-family: 'Gmarket Sans', sans-serif;
    font-weight: 500;
    font-size: 35px;
    line-height: 1;
    color: #5e0223;
  }
}

.htp-rule p {
  font-family: 'Gmarket Sans', sans-serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.46;
  color: #ffffff;
  margin: 0;
}

.button-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.btn-back {
  flex: 0 0 auto;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  img {
    display: block;
    width: 94px;
    height: 94px;
  }
}

.btn-play {
  flex: 1;
  border-radius: 49px;
  padding: 30px;
  font-family: 'Gmarket Sans', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 1;
  text-align: center;
  border: none;
  cursor: pointer;
  background: #ffffff;
  color: #5e0223;
}
</style>
